import { render, staticRenderFns } from "./AudienceAddToEmailFlowModal.vue?vue&type=template&id=193c180b&scoped=true"
import script from "./AudienceAddToEmailFlowModal.vue?vue&type=script&lang=js"
export * from "./AudienceAddToEmailFlowModal.vue?vue&type=script&lang=js"
import style0 from "./AudienceAddToEmailFlowModal.vue?vue&type=style&index=0&id=193c180b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193c180b",
  null
  
)

export default component.exports